<template>
  <section>
   <!-- <div class="centered">
      <v-layout wrap>
        <v-flex md12>
          <v-icon
          size="135"
          color="light-blue darken-4"
          >
            credit_card
          </v-icon>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex md12>
          <v-btn
            class="el-button-login-success"
            @click="dialogVisible = true"
            type="success">
            Ingresar con Tarjeta DJBR
          </v-btn>
        </v-flex>
      </v-layout>
    </div> -->
    <v-btn v-if="alerta === false" small flat color="primary" @click.stop='dialogVisible = true'>
      <p style="color:white;"><v-icon>credit_card</v-icon>&nbsp;<b>Ingresar con tarjeta</b></p>
    </v-btn>
    <v-dialog v-model="dialogVisible" scrollable persistent max-width="750">
      <v-card>
        <v-toolbar dark color="primary">
            <v-card-title><h4>Ingresar con Tarjeta DJBR</h4></v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="cancelar()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar> 
        <v-card-text>
          <br>
          <v-form v-model='valid' ref='form' lazy-validation>
            <v-layout row wrap>
              <v-flex md8 offset-md2>
                <v-select
                  :no-data-text="$t('comun.sin_datos')"
                  v-model="form.tipdoc_codigo"
                  :items="docTypeValues"
                  item-text='tipo_documento'
                  item-value='tipo_documento_codigo'
                  label='Tipo de Documento'
                  prepend-icon="credit_card"
                  :rules='dRules'
                  required
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="form.tipdoc_codigo === '1'">
              <v-flex md8 offset-md2>
                <v-layout wrap>
                  <v-flex md8>
                   <v-text-field
                     v-model="form.numero_docidentidad"
                     :rules='ciRules'
                     label='Número de Cédula de Identidad'
                     maxlength='9'
                     prepend-icon="fingerprint"
                     required
                   ></v-text-field>
                  </v-flex>
                  <v-flex md4>
                    <v-text-field
                      v-model="form.sufijo_docidentidad"
                      label='Complemento SEGIP'
                      :rules='complementoRules'
                      prepend-icon="fingerprint"
                      maxlength='2'
                      class="text-normal"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="form.tipdoc_codigo === '2'">
              <v-flex md8 offset-md2>
                <v-layout wrap>
                  <v-flex sm12 md3>
                    <v-text-field
                      v-model="form.prefijo_docidentidad"
                      label='Prefijo Pasaporte'
                      :rules="textAreaRules"
                      prepend-icon="keyboard_arrow_left"
                      maxlength='5'
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm12 md6>
                    <v-text-field
                     v-model="form.numero_docidentidad"
                     :rules='ciRules'
                     label='Valor Númerico de Pasaporte '
                     maxlength='9'
                     prepend-icon="fingerprint"
                     required
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm12 md3>
                    <v-text-field
                      v-model="form.sufijo_docidentidad"
                      label='Sufijo Pasaporte'
                      :rules="textAreaRules"
                      prepend-icon="keyboard_arrow_right"
                      maxlength='5'
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md8 offset-md2>
                <v-text-field
                  style="font-size: 20px;"
                  v-model="form.tar_codigo_tarjeta"
                  :rules='tarjetaRules'
                  label='Código de su Tarjeta DJBR (sin espacios)'
                  required
                  prepend-icon="credit_card"
                  maxlength='20'
                ></v-text-field>
              </v-flex>
            </v-layout>

            <p>Digite la letras y/o números que aparecen en la imagen </p>
            <v-layout row wrap>
              <v-flex md3 offset-md1>
                <img
                  :src="imgb64"
                  alt="Bolivia">
              </v-flex>
              <v-flex md3 offset-md1>
                <v-text-field
                  v-model="form.captcha"
                  label='Respuesta'
                  :rules='this.useCaptcha ? dRules : []'
                  :required="this.useCaptcha"
                  :maxlength="this.lengthCaptcha"
                  @keydown.enter="login()"
                ></v-text-field>
              </v-flex>
              <v-flex md1>
                <v-icon large @click="crearImagenCaptcha()">cached</v-icon>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout>
            <a @click="$router.push('/activar-tarjeta')"> ¿Tienes una tarjeta? Activala </a>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="loadingB" @click="login()"><v-icon>how_to_reg</v-icon>&nbsp;Ingresar</v-btn>
            <v-btn color="error" :disabled="loadingB" @click="cancelar()"><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
import Captcha from '../mixins/captcha.js';
export default {
  mixins: [ Captcha ],
  props: {
    alerta: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  data () {
    return {
      valid: true,
      dialogVisible: false,
      form: {
        tipdoc_codigo: '1',
        prefijo_docidentidad: '',
        numero_docidentidad: '',
        sufijo_docidentidad: '',
        tar_codigo_tarjeta: '',
        captcha: ''
      },
      docTypeValues: [
        {
          tipo_documento: 'Cédula de Identidad',
          tipo_documento_codigo: '1'
        },
        {
          tipo_documento: 'Pasaporte',
          tipo_documento_codigo: '2'
        }
      ],
      dRules: [v => !!v || 'Este campo es requerido'],
      ciRules: [
        v => !!v || 'El número de Documento es requerido',
        v => /^[0-9]*$/.test(v) || 'El número de Documento no es válido'
      ],
      complementoRules: [
        v => (!/^[CH]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
        v => (!/^[LP]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
        v => (!/^[CB]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
        v => (!/^[OR]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
        v => (!/^[PT]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
        v => (!/^[TJ]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
        v => (!/^[SC]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
        v => (!/^[BN]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición',
        v => (!/^[PN]+$/.test(v)) || 'El complemento no corresponde a un departamento de expedición'
      ],
      textAreaRules: [v => v === '' ? true : /^[a-zA-Z0-9-_/.*(),.;:=#°ñÑÁáÉéÍíóÓúÚäÄëËïÏöÖüÜ \r\n]+$/.test(v) || 'Carácter especial no permitido'],
      textRules: [v => !!v || 'Este campo es requerido',
        v => /^[a-zA-Z0-9-_/.*()"“”,.;:=#°ñÑÁáÉéÍíóÓúÚäÄëËïÏöÖüÜÇç \r\n]+$/.test(v) || 'Carácter especial no permitido'],
      tarjetaRules: [v => !!v || 'Este campo es requerido',
        v => /^[a-zA-Z0-9-]+$/.test(v) || 'Carácter no permitido'],
      imgb64: '',
      tokenCaptcha: '',
      useCaptcha: process.env.USE_CAPTCHA,
      lengthCaptcha: process.env.LENGTH_CAPTCHA,
      loadingB: false
    };
  },
  created () {
    if (this.alerta === true) {
      this.dialogVisible = this.alerta;
    }
    this.crearImagenCaptcha();
  },
  methods: {
    async crearImagenCaptcha () {
      this.form.captcha = '';
      let result = await this.makeText();
      this.tokenCaptcha = result.token;
      this.imgb64 = this.generateCaptcha(result.captcha);
    },
    login () {
      // this.form.sufijo_docidentidad = '';

      if (this.form.sufijo_docidentidad === 'lp' || this.form.sufijo_docidentidad === 'cb' || this.form.sufijo_docidentidad === 'sc' ||
          this.form.sufijo_docidentidad === 'pt' || this.form.sufijo_docidentidad === 'or' || this.form.sufijo_docidentidad === 'ch' ||
          this.form.sufijo_docidentidad === 'tj' || this.form.sufijo_docidentidad === 'bn' || this.form.sufijo_docidentidad === 'pn') {
        this.$message['warning']('El complemento no es un departamento de expedición por ejemplo 1234567-1j');
        this.form.sufijo_docidentidad = '';
      }
      if (this.$refs.form.validate()) {
        // let verify = this.verificarCaptcha(this.useCaptcha, this.tokenCaptcha, this.form.captcha);
        // if (verify) {
        this.loadingB = true;
        this.form.token = this.tokenCaptcha;
        this.$service.post(`control_tarjeta/login_tarjeta`, this.form)
        .then(response => {
          window.localStorage.setItem('djbr_ingreso', 2);
          let url = `${response.url}?data=${response.token}`;
          this.dialogVisible = false;
          window.location.href = url;
          this.loadingB = false;
        }).catch(error => {
          console.log(error);
          this.loadingB = false;
          this.crearImagenCaptcha();
        });
        // } else {
        //   this.crearImagenCaptcha();
        //   this.loadingB = false;
        //   this.$message['warning']('La operación de verificación no es correcta.');
        // }
      } else {
        this.crearImagenCaptcha();
        this.loadingB = false;
        this.$message['warning']('Por Favor complete los datos requeridos..');
      }
    },
    cancelar () {
      this.dialogVisible = false;
      this.$refs.form.reset();
    }
  }
};
</script>
<style lang="scss">
.alert {
  padding: 20px;
  background-color: #0288D1;
  color: white;
}
.centered {
  text-align: center;
  h2 {
    color: #01579B;
  }
  line-height: 1;
}
.el-button-login-success {
  width: 250px !important;
  color: white !important;
  background-color: #8BC34A !important;
}
.el-button-login-primary {
  width: 250px !important;
  color: white !important;
  background-color: #01579B !important;
}
.el-button-login-default {
  width: 250px !important;
  color: white !important;
  background-color: #898b96 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/portal/login/LoginTarjeta.vue